import { z } from 'zod';
import {
  LayoutMode, AvatarShape, FontFamily, FontSize, BorderRadius,
  SelectorKind, PriorityEntity, BlockType, TemplateId
} from '../catalogs/pageCatalog.generated.js';

const seoSchema = z.object({
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  ogImageUrl: z.string().nullable().optional(),
});

const identitySchema = z.object({
  avatarUrl: z.string().nullable().optional(),
  avatarShape: z.nativeEnum(AvatarShape).default(AvatarShape.Round),
});

const customStylesSchema = z.object({
  primaryColor: z.string().nullable().optional(),
  backgroundColor: z.string().nullable().optional(),
  textColor: z.string().nullable().optional(),
  accentColor: z.string().nullable().optional(),
  buttonBackground: z.string().nullable().optional(),
  fontFamily: z.nativeEnum(FontFamily).default(FontFamily.Inter),
  fontSize: z.nativeEnum(FontSize).default(FontSize.Medium),
  borderRadius: z.nativeEnum(BorderRadius).default(BorderRadius.Soft),
});

const scopeSchema = z.object({
  professionalId: z.string().uuid().nullable().optional(),
  placeId: z.string().uuid().nullable().optional(),
  // "Todos os locais e profissionais" do dono — a conta inteira, sem recorte. Só a página de link
  // na bio usa. Campo próprio, e não "os dois ids nulos", porque dois nulos já significam página
  // SEM escopo (defeito), e misturar os dois estados esconderia as quebradas.
  allOfUser: z.boolean().optional(),
});

const blockSchema = z.object({
  id: z.string().uuid(),
  type: z.nativeEnum(BlockType),
  enabled: z.boolean().default(true),
  order: z.number().int().nonnegative(),
  config: z.record(z.string(), z.unknown()).optional().default({}),
});

export const siteFormSchema = z.object({
  schemaVersion: z.literal(3).optional().default(3),
  // templateId (TemplateId int) é campo real do form (TemplateSelector). Precisa estar
  // no schema senão o zodResolver faz strip antes do submit. Nullable p/ criação (escolha
  // do usuário) e edição (sempre carregado). API valida obrigatoriedade na criação.
  templateId: z.nativeEnum(TemplateId).nullable().optional(),
  layoutMode: z.nativeEnum(LayoutMode).default(LayoutMode.Continuous),
  seo: seoSchema.optional().default({}),
  identity: identitySchema.optional().default({}),
  customStyles: customStylesSchema.optional().default({}),
  scope: scopeSchema.optional().default({}),
  blocks: z.array(blockSchema).optional().default([]),
});

export default siteFormSchema;
